import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('patient', 'delete-patient-insurance');

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'patient_insurances',
    {
      type: 'payload',
      selector: ['patientInsuranceId'],
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/requests/delete-patient-insurance.js